import { Component, Host, h, Prop, State, Element, Listen } from '@stencil/core';  
import { guid } from '../../utils/utils';
 
declare global {
	interface Window { 
		isDesignMode: boolean;
		isAdminLoggedIn: boolean; 
	}
}

/**
 * @devnote this component relies on Bootstrap JS and jQuery
 * to update nav-link states on scroll and to handle
 * mobile collapse functionality
 */
declare var jQuery;

@Component({
	tag: 'bs-scroll-spy',
	shadow: false,
})
export class ScrollSpy {
	@Prop() useHeadings: boolean = true;

	@Prop() horizontal: boolean = false;

	@Prop() menuTitle: string;

	@Prop() disableCollapse: boolean = false;

	@State() haveSlotTitle: boolean = false;

	@State() navItems: { title: string; href: string }[] = [];

	@State() collapseable = false;

	@State() collapsed = true;

	@Element() el: HTMLElement;

	@Listen('resize', { target: 'window', passive: true, capture: true })
	handleResize() {
		let collapseable = window.innerWidth < this.collapseTriggerWidth;
		if (this.collapseable !== collapseable) {
			this.collapseable = collapseable;
		}
	}
	@Listen('scroll', { target: 'window', passive: true, capture: true })
	handleScroll() {
		//if (!window.isDesignMode) {
		//	let rectList = this.listElement.getBoundingClientRect();
		//	let rectAfter = this.afterMenuElement.getBoundingClientRect();
		//	this.afterMenuElement.style.top = rectList.bottom + "px";
		//	if (rectAfter.top < rectList.bottom	-5 ) {
		//		this.afterMenuElement.style.opacity = "0";
		//	} else {
		//		this.afterMenuElement.style.opacity = "1";
		//	}
		//}
    }

	collapseTriggerWidth = 992;

	listElementId: string = 'scroll-spy-nav-' + guid();

	listElement: HTMLElement;

	scrollElement: HTMLElement;

	menuTitleSlotElement: HTMLElement;

	afterMenuElement: HTMLElement;

	menuElement: HTMLElement;

	heroElement: HTMLElement;

	isDesignMode: boolean = false;

	handleLinkClick(event: Event) {
		event.preventDefault();

		const url = new URL((event.target as HTMLAnchorElement).href);
		let targetId = url.hash.slice(1);
		setTimeout(() => {
			document.getElementById(targetId).scrollIntoView({ behavior: 'smooth',block: 'start', inline: 'nearest' });
			this.menuElement.innerHTML = document.getElementById(targetId).innerHTML;
		}, 250);
		
	}

	getSafeTitle(text: string) {
		return text
			.toLowerCase()
			.replace(/\s/g, '-')
			.replace(/[+()!?,."'%&:;]/g, '');
	}

	filterAnchorItems(anchor: HTMLElement): boolean {
		if (anchor.closest('[data-spy-ignore]') || anchor.closest('.spy-ignore')) {
			return false;
		}
		return true;
	}

	setupWithHeadings() {
		const headings = this.scrollElement.querySelectorAll('h1,h2');
		const navItems = Array.from(headings)
			.filter(this.filterAnchorItems)
			.reduce((carry, heading: HTMLElement) => {
				let innerTextArray = heading.innerText.split(' ');
				if (null == heading.getAttribute('id')) {
					heading.setAttribute('id', this.getSafeTitle(heading.innerText));
					// @ts-ignore
					heading.style.scrollMarginTop =  this.collapseable ? '120px' : '70px';
				}
				return [
					...carry,
					{
						title:
							heading.dataset.spyTitle ||
							(heading.tagName.toLowerCase() == 'h1'
								? 'Overview'
								: innerTextArray.length > 10 ? innerTextArray.slice(0, 10).join(' ') + '...' : heading.innerText),
						href: `#${heading.getAttribute('id')}`,
					},
				];
			}, []);
		this.navItems = [...navItems];
	}

	setupWithClasses() {
		const anchors = this.scrollElement.querySelectorAll('.scroll-spy-anchor');
		const navItems = Array.from(anchors)
			.filter(this.filterAnchorItems)
			.reduce((carry, anchor: HTMLElement) => {
				if (null == anchor.getAttribute('id')) {
					anchor.setAttribute('id', this.getSafeTitle(anchor.dataset.spyTitle));
				}
				return [
					...carry,
					{
						title: anchor.dataset.spyTitle || anchor.innerText,
						href: `#${anchor.getAttribute('id')}`,
					},
				];
			}, []);
		this.navItems = [...navItems];
	}


	menuTitleSlotElementClone: HTMLElement;
	componentDidLoad() {
		this.useHeadings ? this.setupWithHeadings() : this.setupWithClasses();
		this.handleResize();
		
		this.handleScroll();

		if (this.menuTitleSlotElement.innerText.trim()) {
			this.menuTitleSlotElementClone = (this.menuTitleSlotElement.cloneNode(true) as HTMLElement);
			this.menuTitle = this.menuTitleSlotElementClone.innerText;
			this.haveSlotTitle = true;
		}

		

		if (window.isDesignMode) {
			// don't leave menu-after
			this.isDesignMode = true;
		}
		
	}

	componentDidRender() {
		setTimeout(() => {
			jQuery('body').scrollspy({ target: `#${this.listElementId}`, offset: 250 });
		});
	}

	collapseHTML = () => 
		!this.disableCollapse && (
			<div class="scroll-spy-mobile">
				<button
					class="scroll-spy-collapse-toggle"
					type="button"
					data-toggle="collapse"
					data-target="#scroll-spy-collapse"
					aria-expanded="false"
					aria-controls="scroll-spy-collapse"
				>
					{/* @todo revisit */}
					
					
					{
						<strong ref={(el) => (this.menuElement = el as HTMLElement)}>
							{this.menuTitle || "On this page"}
						</strong>
					}
					<icon-chevron-down />
					<div></div>
				</button>
				<div id="scroll-spy-collapse" class="collapse">
					<ul class="nav nav--scroll-spy nav--scroll-spy-mobile ml-3">
						{this.navItems.map((item,index,arr) => [(
							<li class="nav-item">
								<a class="nav-link" href={item.href} onClick={(evt) => this.handleLinkClick(evt)} data-toggle="collapse" data-target="#scroll-spy-collapse">
									{item.title}
								</a>
							</li>),
							(index == arr.length - 1 && !this.isDesignMode && (
								<li

									ref={el => (this.afterMenuElement = el as HTMLElement)}>
									<slot name="after-menu" ></slot>
								</li>
							))
						])}
						
					</ul>
				</div>
			</div>
		)
	

	render() {
		return (
			<Host
				
			>
				<div class="hero container-fluid border-bottom" style={{ flex : "0 0 100%" }}
					ref={el => (this.heroElement = el as HTMLElement)}>
					<slot name='hero' />
				</div>
				<div
					class={{
						'scroll-spy': true,
						'scroll-spy--horizontal': this.horizontal && !this.collapseable,
						'scroll-spy--vertical': !this.horizontal || this.collapseable,
						'scroll-spy--collapsed': this.collapseable,
						'scroll-spy--slot-disabled': this.disableCollapse,
						'container': true
					}}
				>
				{this.collapseable ? (
					<aside class="scroll-spy-sidebar scroll-spy-sidebar--mobile">
						{this.collapseHTML()}
					</aside>
				) : (
					<aside class="scroll-spy-sidebar scroll-spy-sidebar--desktop">
						<slot name="sidebar"></slot>
						<ul
							id={this.listElementId}
							class="nav nav--scroll-spy"
							ref={el => (this.listElement = el as HTMLElement)}
						>
							
							<li
								ref={el => (this.menuTitleSlotElement = el as HTMLElement)}
								// class="nav-item nav-item-slot d-none"
								class={{
									'nav-item' :true,
									'nav-item-slot' :true,
									'd-none' :!this.haveSlotTitle
								}}
							>
								<slot name="menu-title" />
							</li>
							
							{this.menuTitle && !this.haveSlotTitle && !this.horizontal && (
								<li class="nav-item">
									<strong class="nav-link nav-link--title">
										{this.menuTitle}
									</strong>
								</li>
							)}
							{this.navItems.map((item,index,arr) => [
								 (<li class="nav-item">
									<a
										class="nav-link"
										href={item.href}
										onClick={this.handleLinkClick}
									>
										{item.title}
									</a>
								</li>),
								(index == arr.length -1 && (
									<li
										ref={el => (this.afterMenuElement = el as HTMLElement)}>
										<slot name="after-menu"></slot>
									</li>
								))
							])}
							{(this.isDesignMode && (
								<li class="nav-item">
									<slot name="after-menu" />
								</li>
							))}
							</ul>
					</aside>
				)}
				<div
					class="scroll-spy-content"
					ref={el => (this.scrollElement = el as HTMLElement)}
				>
					<slot />
				</div>
				</div>
			</Host>
		);
	}
}
